import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AppButtons } from '../../../../shared/app-buttons/app-buttons';
import { Banner } from '../../../../shared/banner/banner';
import { AppTooltipComponent } from '../../../../shared/app-tooltip/app-tooltip.component';
import { SummaryStatusBanner } from '../constants/application-review-summary-card.model';

@Component({
  selector: 'app-applicant-review-summary-card',
  imports: [MatIconModule, Banner, AppButtons, AppTooltipComponent],
  templateUrl: './applicant-review-summary-card.html',
  styleUrl: './applicant-review-summary-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplicantReviewSummaryCard {
  readonly applicantName = input<string>('Mahmud Iqbal');
  readonly reviewedCount = input<number>(0);
  readonly totalApplicants = input<number>(0);
  readonly isCurrentApplicantReviewed = input<boolean>(false);
  readonly mafUploaded = input<boolean>(false);
  readonly mandatoryDocsUploaded = input<boolean>(false);
  readonly extractedFieldsFinalized = input<boolean>(false);
  readonly canMarkApplicantReviewed = input<boolean>(false);
  readonly canProceedNextApplicant = input<boolean>(true);
  readonly isReadOnly = input<boolean>(false);

  readonly markApplicantReviewed = output<void>();
  readonly proceedNextApplicant = output<void>();

  readonly reviewedProgressText = computed(() => `(${this.reviewedCount()}/${this.totalApplicants()})`);

  readonly statusBanners = computed<SummaryStatusBanner[]>(() => [
    this.getStatusBanner(this.mafUploaded(), 'MAF Upload'),
    this.getStatusBanner(this.mandatoryDocsUploaded(), 'All Mandatory Docs Uploaded'),
    this.getStatusBanner(this.extractedFieldsFinalized(), 'Extracted Fields Finalized'),
  ]);

  isTextOverflowing(element: HTMLElement | null): boolean {
    if (!element) {
      return false;
    }

    return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
  }

  onMarkReviewedClick(): void {
    if (!this.canMarkApplicantReviewed()) {
      return;
    }

    this.markApplicantReviewed.emit();
  }

  onProceedNextApplicantClick(): void {
    this.proceedNextApplicant.emit();
  }

  private getStatusBanner(isComplete: boolean, message: string): SummaryStatusBanner {
    return {
      variant: isComplete ? 'success' : 'warning',
      message,
      iconName: isComplete ? 'icon-check-circle-green' : 'delete-info',
    };
  }
}
